<template>
  <hero-form :is-new="false" />
</template>

<script>
import HeroForm from '../../components/heros/Form.vue'

export default {
  components: { HeroForm },
}
</script>

  <style>

  </style>
